module.exports = function (settingsService, $templateCache, breakpointsService, $location) {
    return {
        restrict: 'E',
        scope: {
            settingGroup: '@',
            settingName: '@'
        },
        link(scope) {
            scope.isLoaded = false;
            scope.isSelfexclusion = false;
            scope.settingTemplateName = scope.settingGroup + '-' + scope.settingName + '.html';
            //hide signup footer on selfexclusion page
            scope.$on('$locationChangeSuccess', () => {
                scope.isSelfexclusion = scope.settingName === 'FooterContent1' && $location.path() === '/help/self-exclusion';
            });
            settingsService.getSettingValue(scope.settingGroup, scope.settingName).then((value) => {
                if (value && typeof value === 'string') {
                    value = value.replace(/<img\s/g, '<img loading="lazy" ');
                }
                $templateCache.put(scope.settingTemplateName, value);
                scope.isLoaded = true;
                //the below is set as a standard for dynamic content team to use the service to get browser window widths
                // the team uses as: ng-if="breakpoints.isInMediumFormat || breakpoints.isInLargeFormat" or ng-if="breakpoints.isInSmallFormat"
                scope.breakpoints = breakpointsService;
            });
        },
        template: '<div ng-if="isLoaded && !isSelfexclusion"><div ng-include="settingTemplateName"></div></div>'
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/settings/content-setting-directive.js
 **/